export class Role {
  constructor(attrs) {
    Object.assign(this, this.defaults(), attrs);
  }

  defaults() {
    return {
      id: "",
      name: "",
      description: "",
      guard: "admin",
      permissions: [],
    }
  }

  reset() {
    Object.assign(this, this.defaults());
  }
}